module.exports = __webpack_public_path__ + "img/tg.42c9c741.svg";